import { RouteName } from "@/lib/router/routes";
import useAuthStore from "@/stores/useAuthStore";
import { storeToRefs } from "pinia";
import { Router } from "vue-router";

export default function (router: Router) {
  const {
    isSignedIn,
  } = storeToRefs(useAuthStore());

  router.beforeEach(async (to) => {
    if (isSignedIn.value && to.name === RouteName.login) {
      return {
        name: RouteName.index,
      };
    }
  });
}
